<template>
  <div :class="props.customStyle" tabindex="1">
    <span
      v-tooltip.focus.right="{
        value: props.message,
        ...tooltipSetup,
      }"
      tabindex="1"
      @click="(e) => e.target.focus()"
      @mouseenter="(e) => e.target.focus()"
      @mouseleave="(e) => e.target.blur()"
    >
      <HelpIcon :class="props.iconStyle" />
    </span>
  </div>
</template>

<script setup>
import Tooltip from "primevue/tooltip";
import { HelpIcon } from "@/components/shared/icons";

const tooltipSetup = {
  escape: false,
  fitContent: true,
  class: "bg-white shadow rounded white",
  hideDelay: "0.3",
  pt: {
    text: "text-indigo-base p-3 leading-none",
  },
};
const vTooltip = Tooltip;

const props = defineProps({
  customStyle: {
    type: String,
    required: false,
    default: "text-wrap",
  },
  iconStyle: {
    type: String,
    required: false,
    default: "cursor-pointer h-[1.125rem] w-[1.125rem]",
  },
  message: {
    type: String,
    required: false,
    default: "",
  },
});
</script>
